export default __webpack_public_path__ + "static/media/noun-check-3496109.202a39bd.svg";